import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const setVh = () => {
  const vh = (window.visualViewport ? window.visualViewport.height : window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

setVh();

window.addEventListener('resize', setVh, { passive: true });
window.addEventListener('orientationchange', setVh, { passive: true });

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
